import {VscContent} from "./ContentComponent";
import Plan from "../screens/plan/Plan";
import {useModels} from "../../data/modelSource";
import {useSearchParams} from "react-router-dom";


export const VscPlan: React.FC<{}> = (props) => {

    let [searchParams, setSearchParams] = useSearchParams();
    const planId = searchParams.get("id");
    const models = useModels();
    if (models === null) return <div>Loading...</div>
    if (planId === null) return null;
    const model = models.find(model => model.id == planId);
    if (model === undefined) {
        throw new Error('model not found');
    }

    return <Plan model={model} />;
}

